module.exports = __webpack_public_path__ + "img/GA.b2b65523.png";